import React from 'react';
import { styled } from '@mui/system';

interface BadgeProps {
  color?: string;
  isUserMenu?: boolean;
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
}

const BadgeContainer = styled('div')({
  position: 'relative',
  display: 'inline-block',
});

const BadgeDot = styled('span')<{ badgeColor: string; isUserMenu?: boolean }>(({ badgeColor, isUserMenu }) => ({
  position: 'absolute',
  bottom: isUserMenu ? -11 : -15,
  right: isUserMenu ? 7 : 0,
  width: 18,
  height: 18,
  borderRadius: '50%',
  backgroundColor: badgeColor,
  transform: 'translate(50%, -50%)',
}));

export const Badge: React.FC<BadgeProps> = ({ color, children, isUserMenu, onClick }) => (
  <BadgeContainer>
    {children}
    {color && <BadgeDot onClick={onClick} badgeColor={color} isUserMenu={isUserMenu} />}
  </BadgeContainer>
);
